import axios from '@/utils/request'

export default {

  // purchaseReject,//采购单拒绝
  // 	orderRemind,//订单催办
  // 	orderHurry,//订单加急
  // 	orderEdit,//订单修改
  // 	orderRetrieve,//订单撤单
  // 	purchaseRemind,//采购单催单
  // 	purchaseEdit,//采购单编辑
  // 	orderReject,//订单拒绝
  // 	sys,//系统通知
  // 	sup2CusMes,//发给客户的消息
  // cus2SupMes,//发给供应商的消息

  // 2020-08-08
  searchReceived(params) {
    return axios.get('/notices/received', params)
  },
  // 2020-08-08
  searchSent(params) {
    return axios.get('/notices/sent', params)
  },
  // 2020-08-08
  read(id) {
    return axios.put('/notices/' + id + '/read')
  },
  // 2020-08-08
  allRead() {
    return axios.put('/notices/all-read')
  },
  // 2020-12-29
  unreadQty(id) {
    return axios.get('/notices/unread-qty')
  },
  // 2021-09-11
  send(params) {
    return axios.post('/notices/send', params)
  },
  // 2021-09-15
  findByUuid(params) {
    return axios.get('/notices/find-by-uuid', params)
  },

}

